import React from 'react'
import Caption from '../../components/Caption/Caption'
import { Container } from '../../components/Grid/Grid'
import Heading from '../../components/Heading/Heading'
import Whitespace, { WhitespaceProps } from '../../components/Whitespace/Whitespace'
import styles from './SpotlightHeader.module.scss'
import FreeText from '../../components/FreeText/FreeText'
import Icon from '../../components/Icon/Icon'
import Permalink from '../../components/Permalink/Permalink'
import { getIconByName } from '../../icons'
import classNames from 'classnames'

export type ZoneSpotlightHeaderProps = {
  __typename: 'StrapiGQL_ComponentZonesSpotlightHeader'
  title: string
  subtitle?: string
  titleMaxWidth?: string
  subtitleMaxWidth?: string
  buttonText?: string
  buttonLink?: string
  spotlightWhitespace?: WhitespaceProps['type']
}

export default function ZoneSpotlightHeader(props: ZoneSpotlightHeaderProps) {
  const {
    title,
    subtitle,
    titleMaxWidth,
    subtitleMaxWidth,
    buttonText,
    buttonLink,
    spotlightWhitespace,
  } = props
  return (
    <Whitespace type={spotlightWhitespace}>
      <Container className={styles.container}>
        <Heading type="xl" style={{ maxWidth: titleMaxWidth }}>
          {title}
        </Heading>
        {subtitle && (
          <Caption
            type="md"
            className={styles.subtitle}
            style={{ maxWidth: subtitleMaxWidth }}
          >
            {subtitle}
          </Caption>
        )}

        {buttonText && buttonLink && (
          <FreeText className={classNames([styles.buttonContainer])}>
            <Permalink className={styles.linkText} to={buttonLink}>
              {buttonText}
            </Permalink>
            <Icon
              icon={getIconByName('arrow-right')}
              size={24}
              className={styles.arrow}
            />
          </FreeText>
        )}
      </Container>
    </Whitespace>
  )
}
